/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createSackurTetrode } from '../../factoriesAny.js';
export var sackurTetrodeDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  createSackurTetrode: createSackurTetrode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSackurTetrode.generated.js
// module id = 1505
// module chunks = 0